import _extends from "@babel/runtime/helpers/extends";
import React, { forwardRef, useContext } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

// lodash
import _isEmpty from 'lodash/isEmpty';

// constants
import { EMPTY_OBJECT } from '@tekion/tekion-base/app.constants';

// components
import InputTableHeader from '../../../inputTableHeader';
import EmptyPlaceholderComponent from '../../../emptyPlaceholderComponent';
import LoadingComponent from '../../../loadingComponent';
import InnerElementTypeContext from '../../context/innerElementType';

// styles
import styles from './virtualizedInputInnerElementType.module.scss';
function VirtualizedInputTableInnerElementType(props) {
  var children = props.children,
    forwardedRef = props.forwardedRef,
    style = props.style;
  var innerElementTypeProps = useContext(InnerElementTypeContext);
  var _ref = innerElementTypeProps || EMPTY_OBJECT,
    columns = _ref.columns,
    onAction = _ref.onAction,
    sortDetails = _ref.sortDetails,
    headerClassName = _ref.headerClassName,
    data = _ref.data,
    loading = _ref.loading;
  var noDataPresent = _isEmpty(data);
  var showList = !(loading || noDataPresent);
  var showEmptyPlaceHolder = !loading && noDataPresent;
  return /*#__PURE__*/React.createElement("div", {
    ref: forwardedRef,
    style: style
  }, /*#__PURE__*/React.createElement(InputTableHeader, {
    columns: columns,
    onAction: onAction,
    sortDetails: sortDetails,
    headerClassName: cx(headerClassName, styles.tableHeader),
    data: data
  }), loading && /*#__PURE__*/React.createElement(LoadingComponent, {
    loading: loading
  }), showEmptyPlaceHolder && /*#__PURE__*/React.createElement(EmptyPlaceholderComponent, null), showList && /*#__PURE__*/React.createElement("div", {
    className: "relative"
  }, children));
}
VirtualizedInputTableInnerElementType.propTypes = {
  children: PropTypes.array.isRequired,
  forwardedRef: PropTypes.object,
  style: PropTypes.object
};
VirtualizedInputTableInnerElementType.defaultProps = {
  style: EMPTY_OBJECT,
  forwardedRef: null
};
export default /*#__PURE__*/forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(VirtualizedInputTableInnerElementType, _extends({}, props, {
    forwardedRef: ref
  }));
});